import type { Theme } from "@mui/material/styles"

export function fundoNeutroKiosk(theme: Theme): string {
    return theme.palette.mode === 'dark' ? theme.palette.background.paper : '#FAFAFA'
}
